import { render, staticRenderFns } from "./Component-Tranresourcesmanage.vue?vue&type=template&id=2976f365&"
import script from "./Component-Tranresourcesmanage.vue?vue&type=script&lang=js&"
export * from "./Component-Tranresourcesmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports